import type { GamePlatform } from '../schemas/game.js';
import type { PublishingStore } from '../schemas/publishing-destination.js';

// Per-platform store list. Single source of truth for the picker contents.
// Same store can appear on multiple platforms (Steam on PC + Mac + Linux + VR
// is expected); each (platform, store) pair becomes its own destination row.
export const STORES_BY_PLATFORM: Readonly<Record<GamePlatform, readonly PublishingStore[]>> = {
  pc: ['steam', 'epic', 'gog', 'itch_io'],
  mac: ['mac_app_store', 'steam', 'gog', 'itch_io'],
  linux: ['steam', 'gog', 'itch_io'],
  ios: ['app_store'],
  android: ['google_play'],
  console: ['nintendo', 'playstation', 'xbox'],
  vr: ['meta_horizon', 'steam'],
};

export const PUBLISHING_STORE_LABELS: Readonly<Record<PublishingStore, string>> = {
  steam: 'Steam',
  epic: 'Epic Games Store',
  gog: 'GOG',
  itch_io: 'Itch.io',
  mac_app_store: 'Mac App Store',
  app_store: 'App Store',
  google_play: 'Google Play',
  nintendo: 'Nintendo eShop',
  playstation: 'PlayStation Store',
  xbox: 'Xbox Store',
  meta_horizon: 'Meta Horizon Store',
};

// Stores that have (or will have) account-level integrations. The Connect
// button uses this; stores without an integration show a muted
// "No integration available" tag instead. The actual connect flows ship with
// a later Integrations epic.
export const STORES_WITH_INTEGRATION: ReadonlySet<PublishingStore> = new Set([
  'steam',
  'itch_io',
  'app_store',
  'mac_app_store',
  'google_play',
]);

export function storeHasIntegration(store: PublishingStore): boolean {
  return STORES_WITH_INTEGRATION.has(store);
}
